import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getProductionGroupHistory } from "@/api/audit-api";
import { type ConfigurationAuditHistory } from "@/schemas";

type UseProductionGroupHistoryOptions = Omit<
	UseQueryOptions<ConfigurationAuditHistory, Error, ConfigurationAuditHistory, string[]>,
	"queryKey" | "queryFn"
>;

export const useProductionGroupHistory = (
	productionGroupId: string,
	queryConfig: UseProductionGroupHistoryOptions = {},
) => {
	const query = useQuery({
		queryKey: ["production-group-history", productionGroupId],
		queryFn: () => getProductionGroupHistory(productionGroupId),
		enabled: Boolean(productionGroupId),
		...queryConfig,
	});

	return {
		historyData: query.data,
		isLoading: query.isLoading,
		error: query.error,
		refresh: query.refetch,
	};
};
